











    import { Component, Vue, Prop, Watch } from "vue-property-decorator";
    import { NavigationItem as NavItemModel } from "@service/types/NavbarTab";
    import catalogDefaults from "../../../types/catalogDefaults";
    import { getTranslatedCatalogPageName } from "@service/helpers/tabTitlesHelper";
	import { ticketSystemIsEnabled } from "@common/serviceParamsHelper";

    @Component({})
    export default class NavigationItem extends Vue {

        @Prop({ default: false}) navItem: NavItemModel | undefined;
        @Prop({}) isActive: boolean;

        mounted() {
            this.onIsActiveChanged();
        }

        get title() {
            const lang = this.$store.state.session?.language || navigator.language.split('-')[0] || "en";

            if (this.navItem?.tabId.startsWith('catalog')) {
                const catalogs = this.$store.getters['events/selectedEventViewParam']('catalog', null) || catalogDefaults;
                return getTranslatedCatalogPageName(this.navItem.title, catalogs, lang);
            }

            if(this.navItem?.tabId.startsWith('info') && this.navItem?.title !== 'info') {
                return this.navItem.title || this.getTranslatedTitle('info', lang);
            }

            return this.getTranslatedTitle(this.navItem?.title || '', lang);
        }

        get routeName() {
            return this.navItem?.defaultRoute || '';
        }

        get eventId() {
            return this.$store.state.events.selected || this.$route.params.eventId;
        }

        @Watch('isActive')
        onIsActiveChanged() {
            if (!this.isActive) { return; }

            this.$emit('active', this.$el);
        }

        getTranslatedTitle(title: string, lang: string) {
            return (this.$store.getters['services/tabTitle'](title, lang) as string | undefined) || this.$t('common.' + title).toString();
        }

        getParams(tab: NavItemModel | undefined) {

            let params = {};
            if(tab) {
                if (Object.keys(tab.currentLink).length) {
                    if (tab.tabId == 'stage') {
                        this.$delete(tab.currentLink.query, 'my');
                    }
                    params = {
                        name: tab.currentLink.name,
                        params: {
                            ...tab.currentLink.params,
                            ...(ticketSystemIsEnabled() ? null : {eventId: this.eventId}),
                            backend: this.$route.params.backend || this.$store.state.session?.backend
                        },
                        query: tab.currentLink.query,
                        hash: tab.currentLink.hash
                    };
                }
                else {
                    const defaultParams = tab.defaultParams || {};

                    params = {
                        name: tab.defaultRoute,
                        ...defaultParams,
                        params: {
                            backend: this.$route.params.backend || this.$store.state.session?.backend,
                            ...(ticketSystemIsEnabled() ? null : {eventId: this.eventId}),
                            ...defaultParams.params
                        }
                    }
                }
            }
            return params
        }

        onMouseOver() {
            this.$emit('mouseover', this.$el);
        }

        onMouseLeave() {
            this.$emit('mouseleave', this.$el);
        }
    }
